/**
 * app-search — tipos + validador del search-state global del layout `_app`.
 *
 * Centraliza en la URL los overlays montados a nivel `_app` (hoy: el switcher
 * de cuentas), de modo que pegar la URL reabre exactamente la misma pantalla.
 * `validateSearch` omite defaults (no contamina la URL en estado vacío).
 */

export interface AppLayoutSearch {
  /** Switcher de cuentas abierto (`?account=switch`). */
  account?: "switch";
}

/**
 * Valida + normaliza el search del layout. Omite defaults para mantener la URL
 * limpia. Tolerante: valores desconocidos se descartan (no rompe el render).
 */
export function validateAppLayoutSearch(search: Record<string, unknown>): AppLayoutSearch {
  const out: AppLayoutSearch = {};
  if (search.account === "switch") {
    out.account = "switch";
  }
  return out;
}
